import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Auth } from 'src/app/models/auth';
import { GerarBoletoCadastro } from 'src/app/models/gerar-boleto-cadastro';
import { IntencaoDeposito } from 'src/app/models/intencao-deposito';
import { IntencaoDepositoDetalhes } from 'src/app/models/intencao-deposito-detalhes';
import { ReciboIntencaoDeposito } from 'src/app/models/recibo-intencao-deposito';
import { DepositosRequest } from 'src/app/models/request/depositos-request';
import { GerarPixDinamico } from 'src/app/models/request/gerar-pix-dinamico';
import { BRCodePix } from 'src/app/models/response/brcode-pix';
import { QRCodePixDinamico } from 'src/app/models/response/pix-qrcode';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DepositoService } from 'src/app/services/deposito.service';
import { DepositosPagamentosService } from 'src/app/services/depositos-pagamentos.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { IntencaoDepositoFilterOptions } from 'src/app/shared/helpers/models/intencao-deposito-filter-options';
import { VisualizarBoletoService } from '../../../visualizar-boleto/visualizar-boleto.service';
import { MASKS } from 'ng-brazil';
import { SaldoCedenteService } from 'src/app/services/saldo-cedente.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { environment } from 'src/environments/environment';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import { BalanceService } from 'src/app/services/balance.service';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import {saveAs} from 'file-saver';
import { DatePipe } from '@angular/common';
import { Assignor } from 'src/app/models/assignor';

@Component({
  selector: 'app-depositos-pagamentos-list',
  templateUrl: './depositos-pagamentos-list.component.html',
  styleUrls: ['./depositos-pagamentos-list.component.css']
})
export class DepositosPagamentosListComponent implements OnInit {

    @ViewChild('modalQRCodePagar', { static: true })
    modalQRCodePagar: TemplateRef<any>;

    public MASKS = MASKS;
    clickEventsubscription: Subscription;

    public currentUser: Auth;
    public intencoesDeposito: IntencaoDeposito[] = [];
    public intencaoDepositoDetalhes: IntencaoDepositoDetalhes = null;
    public assignorInfo: Assignor;
    private selectedDepositId: number;
    private currentDeposit: any;

    //#region pix
    protected btnEnviarEnable: boolean = false;
    public depositoPixRequest: GerarPixDinamico;
    public qrCodePix: QRCodePixDinamico;
    public brCodePix: BRCodePix;
    //#endregion

    //#region boleto
    public reciboIntencaoDeposito: ReciboIntencaoDeposito = null;
    //#endregion

    //#region filter form
    public codeCtrl: FormControl = new FormControl();
    public refenceCtrl: FormControl = new FormControl();
    public valueCtrl: FormControl = new FormControl();
    public issueDateCtrl: FormControl = new FormControl();
    public processingDateCtrl: FormControl = new FormControl();
    public cancelationDateCtrl: FormControl = new FormControl();
    date = new Date();
    maxDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate());
    //#endregion

    //#region filter
    public filtroPesquisa = '';
    public exibirFiltro = true;
    public filtroOn: boolean = false;
    public filtroCodigo = null
    public filtroReferencia = null;
    public filtroValor = null;
    public filtroEmissao = null;
    public filtroProcessamento = null;
    public filtroCancelamento = null;
    public dataInicio = new Date();
    public dataFim = new Date();
    //#endregion

    //#region pagination
    sortOrder: boolean = false;
    currentPage = 1;
    showItem = '10';
    totalItems = 0;
    collumnName = "name";
    //#endregion

    constructor(
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private modalService: NgbModal,
        private depositoService: DepositoService,
        private visualizarBoletoService: VisualizarBoletoService,
        private depositsPaymentsService: DepositosPagamentosService,
        private transactionService: TransactionService,
        private saldoCedenteService: SaldoCedenteService,
        private cedenteService: CedenteService,
        private relatorioService: RelatorioService,
        private balanceService: BalanceService,
        private router: Router,
        private route: ActivatedRoute,
        private datepipe: DatePipe)
    {
        this.clickEventsubscription = this.depositsPaymentsService.getClickEvent().subscribe(()=>{
            this.pageChanged(1);
        });
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;

        this.selectedDepositId = +this.route.firstChild.snapshot.params['id']
        
        this.currentDeposit = JSON.parse(sessionStorage.getItem('currentDeposit'));
       
        if(this.selectedDepositId && this.currentDeposit){
            if(this.currentDeposit?.boletoInfo){
                this.showVisualizarBoleto(this.currentDeposit?.boletoInfo);
            }
            if(this.currentDeposit?.pixInfo){
                const brCodePix = new BRCodePix();
                brCodePix.brCode = this.currentDeposit?.pixInfo.brCode;
                brCodePix.imagemBRCode = this.currentDeposit?.pixInfo.brCodeImage;
                brCodePix.id = +this.currentDeposit?.pixInfo.brCodeNumber;
                brCodePix.valor = +this.currentDeposit?.pixInfo.value;
                this.showQRCodePagar(this.modalQRCodePagar, this.currentDeposit?.pixInfo, brCodePix);
            }
        }        

        this.dataInicio.setDate(this.dataInicio.getDate()-90);

        this.loadInfo()
        this.pageChanged(this.currentPage);
    }

    private loadInfo() {
        if(JSON.parse(localStorage.getItem('assignorInfo')) == null || JSON.parse(localStorage.getItem('assignorInfo')) == undefined)   {
            this.cedenteService.getAssignorInfo(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                response => {
                    this.assignorInfo = response.result;
                    localStorage.setItem('assignorInfo', JSON.stringify(response.result));

                    const tam = environment.TOTAL_CARACTERE_CNPJ - this.assignorInfo.document.toString().length;

                    let str = this.assignorInfo.document.toString();

                    for (let i = 0; i < tam; i++) { str = '0' + str; }
                        this.assignorInfo.document = str;
                }, error => {
                    this.alertService.error('Ocorreu um erro ao consultar as informações da empresa. Tente novamente mais tarde');
                }
            );
        }
        else{
            this.assignorInfo = JSON.parse(localStorage.getItem('assignorInfo'));
            const tam = environment.TOTAL_CARACTERE_CNPJ - this.assignorInfo.document.toString().length;

            let str = this.assignorInfo.document.toString();

            for (let i = 0; i < tam; i++) { str = '0' + str; }
                this.assignorInfo.document = str;
        }
    }

    pageChanged(event) {
        this.saldoCedenteService.updateBalance(this.currentUser.token.assignorGuid);

        this.currentPage = event;
        const offset = (this.currentPage - 1) * +this.showItem;

        const filterOptions = new IntencaoDepositoFilterOptions();
        filterOptions.q = this.filtroPesquisa;

        const filterObject = new DepositosRequest();
        filterObject.codigo = this.filtroCodigo;
        filterObject.referencia = this.filtroReferencia;
        filterObject.valor = this.filtroValor;
        filterObject.dataEmissao= this.filtroEmissao;
        filterObject.dataProcessamento = this.filtroProcessamento;
        filterObject.dataCancelamento = this.filtroCancelamento;
        filterObject.dataInicio = this.dataInicio;
        filterObject.dataFim = this.dataFim;

        this.alertService.clear();
        this.depositoService
        .getAllPaged(
            this.currentUser.token.assignorGuid,
            this.currentUser.token.userReferenceId,
            offset,
            +this.showItem,
            filterOptions,
            filterObject
        )
        .subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.intencoesDeposito = response.result.itens;
                    this.totalItems = response.result.total;
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Ocorreu um erro ao paginar as instenções de depósito');
            }
        );
    }

    showItemChanged(event) {
        this.showItem = event;
        this.pageChanged(1);
    }

    showVisualizarIntencaoDeposito(content: any, intencaoDepositoGuid: string) {
        // chamar api
        this.depositoService.getDetails(intencaoDepositoGuid, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                this.intencaoDepositoDetalhes = response.result;
                this.modalService.open(content, { centered: true, size: 'lg' });
                } else {
                this.alertService.error(response.message);
                }
            }, error => {
                this.alertService.error('Ocorreu um erro ao visualizar intenção de depósito');
            }
        );
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    applyFilter() {
        this.filtroCodigo = this.codeCtrl.value == null ? '' : this.codeCtrl.value;
        this.filtroReferencia = this.refenceCtrl.value == null ? '' : this.refenceCtrl.value;
        this.filtroValor = this.valueCtrl.value == null ? '' : this.valueCtrl.value.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
        this.filtroEmissao = this.issueDateCtrl.value == null ? '' : this.issueDateCtrl.value;
        this.filtroProcessamento = this.processingDateCtrl.value == null ? '' : this.processingDateCtrl.value;
        this.filtroCancelamento = this.cancelationDateCtrl.value == null ? '' : this.cancelationDateCtrl.value;
        this.filtroOn = true;

        this.pageChanged(1);
    }

    deleteFilter(){
        this.filtroCodigo = null
        this.filtroReferencia = null;
        this.filtroValor = null;
        this.filtroEmissao = null;
        this.filtroProcessamento = null;
        this.filtroCancelamento = null;
        this.filtroOn = false;
        this.dataInicio = new Date();
        this.dataFim = new Date();
        this.dataInicio.setDate(this.dataInicio.getDate()-90);

        this.codeCtrl.setValue(null);
        this.refenceCtrl.setValue(null);
        this.valueCtrl.setValue(null);;
        this.issueDateCtrl.setValue(null);;
        this.processingDateCtrl.setValue(null);
        this.cancelationDateCtrl.setValue(null);

        this.pageChanged(1);
    }

    setPeriod(inicio,date: Date){
        if(inicio && this.dataFim <= date) {
            this.dataInicio = this.dataFim;
            this.dataFim = date;
        } else if(inicio){
            this.dataInicio  = date;
        } else if(!inicio && this.dataInicio >= date) {
            this.dataFim = this.dataInicio;
            this.dataInicio = date;
        } else {
            this.dataFim = date;
        }
    }

    showQRCodePagar(content: any, item: any, brCodePIX: BRCodePix) {
        this.brCodePix = new BRCodePix();
        /* console.log(brCodePIX) */
        this.brCodePix = brCodePIX;
        if(item?.dataProcessamento != null || item?.dataCancelamento != null){
            this.alertService.error('Este QR Code PIX não pode ser exibido pois ele já foi pago ou finalizado.')
            return;
        }
        if(brCodePIX == null)
            this.alertService.error('Ocorreu um erro ao visualizar o QR Code');
        else{
            this.btnEnviarEnable = false;
            this.modalService.open(content, { centered: true, size: 'xl' });
            sessionStorage.removeItem('currentDeposit');
        }
    }

    gerarBoleto(item: IntencaoDeposito) {
        this.depositoService.generateBoleto(item.intencaoDepositoGuid, new GerarBoletoCadastro(item.valor, null), this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                this.visualizarBoletoService.arquivoBase64 = response.result.pdf;
                this.router.navigate(['portal/boleto']);
                } else {
                this.alertService.error(response.message);
                }
            }, error => {
                this.alertService.error('Ocorreu um erro ao gerar boleto');
            }
        );
    }

    showVisualizarBoleto(item: IntencaoDeposito | any) {
        this.visualizarBoletoService.arquivoBase64 = item.boletoInfo?.pdf || item.pdf;
        this.router.navigate(['portal/boleto']);
    }

    showVisualizarReciboIntencaoDeposito(content: any, intencaoDepositoGuid: string) {
        // chamar api
        this.depositoService.getRecibo(intencaoDepositoGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                this.reciboIntencaoDeposito = response.result;
                this.modalService.open(content, { centered: true, size: 'lg' });
                } else {
                this.alertService.error(response.message);
                }
            }, error => {
                this.alertService.error('Ocorreu um erro ao obter recibo');
            }
        );
    }

    cancelarDeposito(depositoID: string) {
        this.transactionService.CancelarDeposito(depositoID, this.currentUser.token.userReferenceId).subscribe(
          response => {
            if (response.status === ApiError.Sucesso) {
              this.alertService.success('Intenção de depósito cancelada com sucesso');
              this.pageChanged(1);
            } else {
              this.alertService.error(response.message);
            }
          },
          error => {
            this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
          }
        );
      }

    toPurchaseDetails(item){
        this.router.navigate([`portal/minhasrecargas/details/${item}`]);
    }

    showVisualizarRPS(depositoId: number){
        this.depositoService.getRPS(depositoId)
        .subscribe(response => {
            if (response.status === ApiError.Sucesso) {
                const pdfService = new PdfService();
                pdfService.generatePdfRps(response.result).getBase64((base) => {
                    this.visualizarBoletoService.arquivoBase64 = 'data:application/pdf;base64,'+base;
                    this.router.navigate(['portal/boleto']);
                });
            } else {
              this.alertService.error(response.message);
            }
        },
        error => {
            this.alertService.error(
              'Ocorreu um erro ao gerar o RPS'
            );
        });
    }

    showVisualizarNFSE(depositoId: string){
        this.depositoService.getNfs(this.currentUser.token.assignorGuid, depositoId)
        .subscribe(response => {
            if (response.status === ApiError.Sucesso) {
                    this.visualizarBoletoService.arquivoBase64 = 'data:application/pdf;base64,'+response.result;
                    this.router.navigate(['portal/boleto']);
            } else {
              this.alertService.error(response.message);
            }
        },
        error => {
            this.alertService.error(
              'Ocorreu um erro ao baixar o Nota Fiscal'
            );
        });
    }

    exportExtractExcel(){
        var result = [];
        let date: any = new Date();
        date = date.toLocaleDateString('pt-BR');
        date = date.split('/');

        const excelService = new ExcelService();
        const worksheets = new Array<WorksheetData>();
        const ws = new WorksheetData();
        ws.worksheetTitle = 'aportes_pagamentos_' + date[2] + '-' + date[1] + '-' + date[0];
        ws.worksheetHeaders = ['Código','Referência','Código da recarga','Tipo','Status','Valor','Emissão','Vencimento','Processamento','Cancelamento'];
        ws.WorksheetRows = [];
        // /*

        const filterOptions = new IntencaoDepositoFilterOptions();
        filterOptions.q = this.filtroPesquisa;

        const filterObject = new DepositosRequest();
        filterObject.codigo = this.filtroCodigo;
        filterObject.referencia = this.filtroReferencia!=null?'%'+this.filtroReferencia+'%':null;
        filterObject.valor = this.filtroValor;
        filterObject.dataEmissao= this.filtroEmissao;
        filterObject.dataProcessamento = this.filtroProcessamento;
        filterObject.dataCancelamento = this.filtroCancelamento;


        this.depositoService
        .getAllPaged(this.currentUser.token.assignorGuid,this.currentUser.token.userReferenceId,0,+this.totalItems,filterOptions,filterObject)
        .subscribe( response => {
            if (response.status === ApiError.Sucesso) {
                result = response.result.itens;

                result.forEach((r) => {
                    const lr = new Array<string>();
                    lr.push(r.intencaoDepositoId);
                    lr.push(r.identificador!=null?r.identificador:'Sem referência');
                    lr.push(r.compraId!=null?r.compraId:'-');
                    lr.push(r.tipoDeposito);
                    lr.push(r.status );
                    lr.push(r.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
                    lr.push(this.datepipe.transform(r.dataCadastro, 'dd/MM/yyyy HH:mm'));
                    lr.push(this.datepipe.transform(r.dataVencimento, 'dd/MM/yyyy'));
                    lr.push(this.datepipe.transform(r.dataProcessamento, 'dd/MM/yyyy HH:mm'));
                    lr.push(this.datepipe.transform(r.dataCancelamento, 'dd/MM/yyyy'));
                    ws.WorksheetRows.push(lr);
                });

                worksheets.push(ws);

                excelService.generateExcelReport('Aportes e Pagamentos', worksheets, null).xlsx
                .writeBuffer().then((data) => {
                    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    saveAs(blob, ws.worksheetTitle + '.xlsx');
                });
            } else {
                this.alertService.error(response.message);
            }
        },
        error => {
            this.alertService.error('Ocorreu um erro ao paginar as intenções de depósito');
        });
    }

    exportExtractPdf(){
        let result = [];
        let date: any = new Date();
        date = date.toLocaleDateString('pt-BR');
        date = date.split('/');

        const pdfData = new PdfData();
        pdfData.PdfTitle = 'aportes_pagamentos_' + date[2] + '-' + date[1] + '-' + date[0];
        pdfData.PdfHeaders = ['Código','Referência','Código da recarga','Tipo','Status','Valor','Emissão','Vencimento','Processamento','Cancelamento'];
        pdfData.PdfRows = [];

        const filterOptions = new IntencaoDepositoFilterOptions();
        filterOptions.q = this.filtroPesquisa;

        const filterObject = new DepositosRequest();
        filterObject.codigo = this.filtroCodigo;
        filterObject.referencia = this.filtroReferencia!=null?'%'+this.filtroReferencia+'%':null;
        filterObject.valor = this.filtroValor;
        filterObject.dataEmissao= this.filtroEmissao;
        filterObject.dataProcessamento = this.filtroProcessamento;
        filterObject.dataCancelamento = this.filtroCancelamento;


        this.depositoService
        .getAllPaged(this.currentUser.token.assignorGuid,this.currentUser.token.userReferenceId,0,+this.totalItems,filterOptions,filterObject)
        .subscribe( response => {
            if (response.status === ApiError.Sucesso) {
                result = response.result.itens;

                result.forEach((r) => {
                    const lr = new Array<string>();
                    lr.push(r.intencaoDepositoId);
                    lr.push(r.identificador!=null?r.identificador:'Sem referência');
                    lr.push(r.compraId!=null?r.compraId:'-');
                    lr.push(r.tipoDeposito);
                    lr.push(r.status );
                    lr.push(r.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
                    lr.push(this.datepipe.transform(r.dataCadastro, 'dd/MM/yyyy HH:mm'));
                    lr.push(this.datepipe.transform(r.dataVencimento, 'dd/MM/yyyy'));
                    lr.push(this.datepipe.transform(r.dataProcessamento, 'dd/MM/yyyy HH:mm'));
                    lr.push(this.datepipe.transform(r.dataCancelamento, 'dd/MM/yyyy'));
                    pdfData.PdfRows.push(lr);
                });

                /*let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');
                filter += (this.filtroOn && this.filtro.type)  ? ' - Tipo: ' + this.filtro.type: '';
                filter += (this.filtroOn && this.filtro.stauts)  ? ' - Stauts: ' + this.filtro.stauts : '';
                filter += (this.filtroOn && this.filtro.value)  ? ' - Valor: ' + this.filtro.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '';
                filter += (this.filtroOn && this.filtro.purchaseId)  ? ' - Cód. Recarga: ' + this.filtro.purchaseId : '';
        */
                const pdfService = new PdfService();
                pdfService.generatePdfReport('Aportes e Pagamentos',pdfData,null,null,true).getBlob((blob) => {
                saveAs(blob, pdfData.PdfTitle + '.pdf');
                });
            } else {
                this.alertService.error(response.message);
            }
        },
        error => {
        this.alertService.error('Ocorreu um erro ao paginar o relatorio');
        });
    }
}
